<template>
  <div class="activation-statistics-list table-hook fadeInRight" v-loading="loading">
    <div class="title-box">
      <span class="m-title">激活统计列表</span>
      <el-form ref="searchForm" :model="searchForm" inline class="hook right themed-form search-form">
        <el-form-item label="代理商:">
          <el-select v-model="searchForm.agentId" filterable clearable placeholder="请选择代理商">
            <el-option 
              v-for="item in agentThreeLists" 
              :key="item.agentId" 
              :label="item.agentName" 
              :value="item.agentId">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" icon="el-icon-download" class="themed-button" @click="exportData">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <div class="content-box">
      <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
        <el-table-column label="统计日期" prop="statisticsDate" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="客户名字" prop="customerName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="客户账号" prop="customerAccount" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="客户层级" prop="customerLevel" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="发货数" prop="shippingCount" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column label="销售金额" prop="salesAmount" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.salesAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="销售笔数" prop="salesOrderCount" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column label="销售客单价" prop="salesUnitPrice" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.salesUnitPrice) }}
          </template>
        </el-table-column>
        <el-table-column label="激活网卡数" prop="activatedCardCount" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="激活占比" prop="activationRate" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatPercent(scope.row.activationRate) }}
          </template>
        </el-table-column>
        <el-table-column label="成本价" prop="costPrice" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.costPrice) }}
          </template>
        </el-table-column>
        <el-table-column label="利润" prop="profit" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.profit) }}
          </template>
        </el-table-column>
        <el-table-column label="线上订单金额" prop="onlineOrderAmount" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.onlineOrderAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="线上订单笔数" prop="onlineOrderPackageCount" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="线上订单客单价" prop="onlineOrderUnitPrice" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.onlineOrderUnitPrice) }}
          </template>
        </el-table-column>
        <el-table-column label="预存金额" prop="prepaidAmount" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.prepaidAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="预存赠送金额" prop="giftAmount" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.giftAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="预存笔数" prop="prepaidOrderCount" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="预存客单价" prop="prepaidUnitPrice" width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.prepaidUnitPrice) }}
          </template>
        </el-table-column>
        <el-table-column label="极速会员金额" prop="expressVipAmount" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.expressVipAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="极速会员笔数" prop="expressVipOrderCount" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="极速会员客单价" prop="expressVipUnitPrice" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.expressVipUnitPrice) }}
          </template>
        </el-table-column>
        <el-table-column label="绑定手机数" prop="bindPhoneCount" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="绑卡率" prop="bindCardRate" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatPercent(scope.row.bindCardRate) }}
          </template>
        </el-table-column>
        <el-table-column label="领取赠送卡数" prop="receiveGiftCardCount" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="领取赠送率" prop="receiveGiftRate" width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatPercent(scope.row.receiveGiftRate) }}
          </template>
        </el-table-column>
        <el-table-column label="首充笔数" prop="firstRechargeCount" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="首充率" prop="firstRechargeRate" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatPercent(scope.row.firstRechargeRate) }}
          </template>
        </el-table-column>
        <el-table-column label="实名卡数" prop="realNameCardCount" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="实名率" prop="realNameRate" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatPercent(scope.row.realNameRate) }}
          </template>
        </el-table-column>
        <el-table-column label="本月续充笔数" prop="monthlyRenewCount" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="本月续充率" prop="monthlyRenewRate" width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatPercent(scope.row.monthlyRenewRate) }}
          </template>
        </el-table-column>
        <el-table-column label="本月续费金额" prop="monthlyRenewAmount" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.monthlyRenewAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="总网卡数" prop="totalCardCount" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="在用网卡数" prop="activeCardCount" width="110" show-overflow-tooltip></el-table-column>
        <el-table-column label="未激活网卡数" prop="inactiveCardCount" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="离网数" prop="offlineCardCount" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column label="退款金额" prop="refundAmount" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.refundAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="退款笔数" prop="refundOrderCount" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="退款占比" prop="refundRate" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatPercent1(scope.row.refundRate) }}
          </template>
        </el-table-column>
        <el-table-column label="回收设备" prop="recycleDeviceCount" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="广告投入" prop="advertisingInput" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatMoney(scope.row.advertisingInput) }}
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remarks" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" class="themed-button" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 15, 20, 50, 100]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog title="编辑激活统计" :visible.sync="editDialogVisible" width="600px">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="客户名字:">
              <el-input v-model="editForm.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户账号:">
              <el-input v-model="editForm.customerAccount" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发货数:">
              <el-input-number v-model="editForm.shippingCount" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成本价:">
              <el-input-number v-model="editForm.costPrice" :precision="2" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="广告投入:">
              <el-input-number v-model="editForm.advertisingInput" :precision="2" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-form-item label="备注:">
          <el-input v-model="editForm.remarks" type="textarea" rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        
        <el-button type="primary" class="themed-button" @click="submitEdit">确 定</el-button>
        <el-button class="themed-button"   type="primary"  @click="editDialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getActivationStatisticsList, updateActivationStatistics, exportActivationStatistics, agentListForUser } from '@/api/staticsManagement/activationStatisticsList'
import { messageBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'

export default {
  name: 'ActivationStatisticsList',
  mixins: [resize],
  data() {
    return {
      loading: false,
      searchForm: {
        agentId: '',
        pageNo: 1,
        pageSize: 15
      },
      agentThreeLists: [],
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
      editDialogVisible: false,
      editForm: {
        id: '',
        customerName: '',
        customerAccount: '',
        shippingCount: 0,
        costPrice: 0,
        advertisingInput: 0,
        remarks: ''
      }
    }
  },
  mounted() {
    this.getAgentListForUser()
    this.loadData()
  },
  methods: {
    // 获取代理商列表
    getAgentListForUser() {
      agentListForUser().then(res => {
        this.agentThreeLists = res || []
      })
    },
    
    // 加载数据
    loadData() {
      this.loading = true
      const params = {
        ...this.searchForm,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      }
      
      getActivationStatisticsList(params).then(res => {
        this.tableData = res.rows || []
        this.total = res.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    
    // 搜索
    searchData() {
      this.currentPage = 1
      this.loadData()
    },
    
    // 导出数据
    exportData() {
      const params = {
        agentId: this.searchForm.agentId
      }
      
      exportActivationStatistics(params).then(res => {
        if (res.system_result_key == '0') {
          this.$alert('导出成功，请到导出记录中下载', '提示', {
            confirmButtonText: '确定',
          }).then(() => {
            this.$router.push('/tob/i_export_list')
          })
        } else {
          this.$message({
            showClose: true,
            message: res.system_result_message_key || '导出失败',
            type: 'error'
          })
        }
      }).catch(() => {
        this.$message({
          showClose: true,
          message: '导出失败，请重试',
          type: 'error'
        })
      })
    },
    
    // 编辑
    handleEdit(row) {
      this.editForm = {
        id: row.id,
        customerName: row.customerName,
        customerAccount: row.customerAccount,
        shippingCount: row.shippingCount || 0,
        costPrice: row.costPrice || 0,
        advertisingInput: row.advertisingInput || 0,
        remarks: row.remarks || ''
      }
      this.editDialogVisible = true
    },
    
    // 提交编辑
    submitEdit() {
      const params = {
        id: this.editForm.id,
        shippingCount: this.editForm.shippingCount,
        costPrice: this.editForm.costPrice,
        advertisingInput: this.editForm.advertisingInput,
        remarks: this.editForm.remarks
      }
      
      updateActivationStatistics(params).then(() => {
        messageBox(this, '更新成功')
        this.editDialogVisible = false
        this.loadData()
      })
    },
    
    // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadData()
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    
    // 格式化金额
    formatMoney(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      return Number(value).toFixed(2)
    },
    
    // 格式化百分比
    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }
      return value*100 + '%'
    },
	
	formatPercent1(value) {
	  if (value === null || value === undefined || value === '') {
	    return '-'
	  }
	  return value
	}
  }
}
</script>

<style scoped>
.activation-statistics-list {
  padding: 20px;
}

.title-box {
  margin-bottom: 20px;
}

.m-title {
  font-size: 18px;
  font-weight: bold;
  margin-right: 20px;
}

.search-form {
  display: inline-block;
}

.content-box {
  margin-bottom: 20px;
}

.pagination {
  text-align: center;
}

.themed-button {
  background-color: #409EFF;
  border-color: #409EFF;
  color: white;
}

.themed-button:hover {
  background-color: #66B1FF;
  border-color: #66B1FF;
}

.themed-button.el-button--success {
  background-color: #67C23A;
  border-color: #67C23A;
}

.themed-button.el-button--success:hover {
  background-color: #85CE61;
  border-color: #85CE61;
}
</style> 